import { post } from '../base';

export function create({ name, isPrivate }: { name: string; isPrivate: boolean }): Promise<string> {
  const updateContext = isPrivate ? 'users' : 'pos';
  return post(`v5/${updateContext}/collections`, { json: { name } }).json();
}
